import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { PluginTemplate } from "types/generated";

const PluginTemplatesTableDescriptionCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<PluginTemplate>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={template.description} />
    </TableSimpleCell>
  );
};

export default PluginTemplatesTableDescriptionCell;
